import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { CommonService, ClientWalkInService, SubscribeService, PromoTypeService, PromoReferenceService, OctTypeService } from '../../../services/index';
import { ClientWalkInModel } from '../../../model/index';
import { MdOption, MdSelect } from '@angular/material';
import { Renderer2 } from '@angular/core';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { trailModelDetComponent } from '../../common/trailModalDet.component';

@Component({
    selector: 'add-client-walk-in-tab',
    templateUrl: './addClientWalkIn.component.html'
})
export class AddClientWalkInComponent implements OnInit {
    service = false;
    assign = false;
    showReference: boolean;
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }
    // @Input() set clientSearchEmit(val: any[]) {
    //     debugger;
    // }
    emplistCtrl: FormControl;
    emplistCtrltest: FormControl;
    emplistCtrltrail: FormControl;
    srclistCtrl: FormControl;
    potCusCtrl: FormControl;
    statusCusCtrl: FormControl;
    pocCusCtrl: FormControl;
    statusWalkCusCtrl: FormControl;
    travelExpenseCtrl: FormControl;
    storePromoCusCtrl: FormControl;
    cusConnectCtrl: FormControl;
    haUserCtrl: FormControl;
    promotestingCtrl: FormControl;
    ostDoneCtrl: FormControl;
    bilateralWillingCtrl: FormControl;
    billGenCtrl: FormControl;
    promotrailCtrl: FormControl;
    potCtrl: FormControl;
    drConsCtrl: FormControl;
    folStatusCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    referenceCtrl1: FormControl;
    // oldReferenceCtrl: FormControl; // Removed - Old Reference is now readonly
    // testingtypeCtrl: FormControl;
    halistCtrl: FormControl;
    assignToCtrl: FormControl;
    servicenoCtrl: FormControl;
    calltypeCtrl: FormControl;
    branchCtrl: FormControl;
    sessionClassCtrl: FormControl;
    sessionCountCtrl: FormControl;
    therapyPackageCtrl: FormControl;
    clientFeedbackCtrl: FormControl;
    store_hvCtrl: FormControl;
    potCusOptList: any[];
    statusList: any[];
    pocList: any[] = [];
    statusWalkinList: any[];
    storePromoList: any[];
    cusConnectList: any[];
    userList: any[];
    promotestingList: any[];
    ostDoneList: any[];
    bilateralWillingList: any[];
    billList: any[];
    haList: any[] = [];
    additionhaList: any[] = [];
    empList: any[] = [];
    emptestList: any[] = [];
    emptrailList: any[] = [];
    srcList: any[] = [];
    promotrailList: any[];
    drList: any[];
    assignToList: any[];
    clientList: any[];
    columns = [];
    branchList: any[] = [];
    sessionClassList: any[];
    therapyPackageList: any[];
    clientFeedbackList: any[];
    store_hvOptList: any[];
    pocListArray: any[];
    filteredItems: Observable<any[]>;
    filteredHa: Observable<any[]>;
    filteredReference: Observable<any[]>;
    filteredReference1: Observable<any[]>;
    // filteredOldReference: Observable<any[]>; // Removed - Old Reference is now readonly
    filteredStatus: Observable<any[]>;
    // filteredTypes: Observable<any[]>;
    filteredEmp: Observable<any[]>;
    filteredEmptest: Observable<any[]>;
    filteredEmptrail: Observable<any[]>;
    filteredSrc: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    // callTypeList: any[];
    complaintList: any[];
    allComplaintList: any[];
    filteredStatusList: Observable<any[]>;
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    batteryList$: any[] = [];
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    batteryCtrl: FormControl;

    // Promo-related properties for Phone Tracking (exactly like client master)
    promoTypeOptions: any[] = [];
    promoReferenceOptions: any[] = [];
    filteredPromoReferenceOptions: any[] = [];

    octTypeList: any[] = [];
    octInitiatedByCtrl: FormControl;
    octInitiatedByList: any[] = [];
    filteredOctInitiatedBy: Observable<any[]>;

    @Input() clientInData: ClientWalkInModel[] = [];
    @ViewChild('halistAutoComp') halistAutoComp;
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('branchAutoComp') branchAutoComp;
    @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('mdscrolllist') matSelect: MdSelect;
    @ViewChild('myinput') input: ElementRef;
    itemList: any[] = [];
    testingList: any[] = [];
    modelStrList: any[] = [];
    brandList: any[] = [];
    brandModelList: any[] = [];
    familyList: any[] = [];
    seriesList: any[] = [];
    performanceList: any[] = [];
    powerList: any[] = [];
    batteryList: any[] = [];
    colorList: any[] = [];
    teleAudiologyList: any[] = [];
    brandIdList: any[] = [];
    brandModelIdList: any[] = [];
    familyIdList: any[] = [];
    seriesIdList: any[] = [];
    performanceIdList: any[] = [];
    powerIdList: any[] = [];
    batteryIdList: any[] = [];
    colorIdList: any[] = [];
    pocStrList: any[] = [];
    storeUserList: any[] = [];
    isLoading: boolean = false;
    minDate: any;
    hasEditDisabled: boolean = false;
    subscribeBranch;
    user_branch_name: any = "";
    user_branch_type: any = "";


    constructor(
        public store: Store<fromRootStore.State>,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private render: Renderer2,
        private clientWalkInService: ClientWalkInService, public subscribeService: SubscribeService, private modalService: BsModalService,
        private promoTypeService: PromoTypeService, private promoReferenceService: PromoReferenceService,
        private octTypeService: OctTypeService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        this.pocCusCtrl = new FormControl();
        this.statusWalkCusCtrl = new FormControl();
        this.storePromoCusCtrl = new FormControl();
        this.cusConnectCtrl = new FormControl();
        this.travelExpenseCtrl = new FormControl();

        this.showReference = false;
        this.service = false;
        //  this.haUserCtrl = new FormControl();

        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidStatus(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Testing" && ledgerID != "Trial" && ledgerID != "Re-Check up"
                && ledgerID != "Re-Trial" && ledgerID != "Fitting" && ledgerID != "Programing"
                && ledgerID != "Re-Programing" && ledgerID != "Re-Trial-Testing"
                && ledgerID != "Programing-Others" && ledgerID != "Re-Program-Others" && ledgerID != "Mould" && ledgerID != "OCT" && ledgerID != "Therapy" && ledgerID != "Assessment") {
                retVal = { inValidStatus: true };
            }
            if (this.clientInData['mode'] == 'Edit' && this.clientInData['disp_status'] == 'Mould') {
                if (this.clientInData['status'] == "Trial" || this.clientInData['status'] == "Testing") {
                    retVal = { inValidStatus: true };
                }
            }
            return retVal;
        }

        function hasValidWalkinStatus(input: FormControl) {
            let walkID = input.value, retVal = null;
            if (walkID != "Normal" && walkID != "Exchange" && walkID != "Sales Return"
            ) {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }
        function hasValidStorePromo(input: FormControl) {
            let walkID = input.value, retVal = null;
            if (walkID != "Yes" && walkID != "No"
            ) {
                retVal = { inValidStorePromo: true };
            }

            return retVal;
        }
        function hasValidCusConnect(input: FormControl) {
            let walkID = input.value, retVal = null;
            if (walkID != "Yes" && walkID != "No"
            ) {
                retVal = { inValidStorePromo: true };
            }

            return retVal;
        }
        this.servicenoCtrl = new FormControl();
        this.calltypeCtrl = new FormControl('', [
            Validators.required
        ]);
        this.statusCusCtrl = new FormControl('', [
            Validators.required,
            hasValidStatus.bind(this)
        ]);

        this.filteredStatus = this.statusCusCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterStatusItems(name) : this.statusList.slice());

        this.statusWalkCusCtrl = new FormControl('', [
            Validators.required,
            hasValidWalkinStatus.bind(this)
        ]);
        this.storePromoCusCtrl = new FormControl('', [
            Validators.required,
            hasValidStorePromo.bind(this)
        ]);
        this.cusConnectCtrl = new FormControl('', [
            Validators.required,
            hasValidCusConnect.bind(this)
        ]);
        // this.statusList = ['Testing', 'Trial', 'Re-Check up', 'Re-Trial',
        //     'Fitting', 'Programing', 'Re-Programing', 'Re-Trial-Testing', 'Programing-Others', 'Re-Program-Others','Mould'];
        this.statusList = ['Testing', 'Trial', 'Therapy', 'Programing', 'Re-Programing', 'Re-Check up', 'Re-Trial', 'Fitting', 'Mould', 'OCT', 'Assessment','Cleaning'];
        if (this._params['tabParams'] == 'HV Entry' || this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment' || this._params['tabParams'] == 'SOA Entry') {
            this.statusList = ['Programing', 'Re-Programing', 'Re-Check up', 'Re-Trial', 'Fitting', 'Mould','Cleaning'];
        }
        // this.loadPocList();

        this.statusWalkinList = ['Normal', 'Exchange', 'Sales Return'];
        this.storePromoList = ['Yes', 'No'];
        this.cusConnectList = ['Yes', 'No'];
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidUser(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidHAuser: true };
            }

            return retVal;
        }
        this.haUserCtrl = new FormControl('', [
            Validators.required,
            hasValidUser.bind(this)
        ]);
        this.userList = ['Yes', 'No'];

        function hasValidBill(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidBill: true };
            }

            return retVal;
        }
        this.billGenCtrl = new FormControl('', [
            Validators.required,
            hasValidBill.bind(this)
        ]);
        this.billList = ['Yes', 'No'];

        function hasValidTesting(input: FormControl) {
            let testingValue = input.value, retVal = null;
            const validTestingTypes = ['OST', 'Trial Not Willing', 'Yes', 'No'];
            if (testingValue && !validTestingTypes.includes(testingValue)) {
                retVal = { inValidPromoTesting: true };
            }

            return retVal;
        }
        this.promotestingCtrl = new FormControl('', [
            Validators.required,
            hasValidTesting.bind(this)
        ]);
        this.promotestingList = ['OST', 'Trial Not Willing', 'Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- OST DONE
        function hasValidOstDone(input: FormControl) {
            let ostValue = input.value, retVal = null;
            if (ostValue && ostValue != "Yes" && ostValue != "No") {
                retVal = { inValidOstDone: true };
            }
            return retVal;
        }
        this.ostDoneCtrl = new FormControl('', [hasValidOstDone.bind(this)]);
        this.ostDoneList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- BILATERAL WILLING CLIENT
        function hasValidBilateralWilling(input: FormControl) {
            let bilateralValue = input.value, retVal = null;
            if (bilateralValue && bilateralValue != "Yes" && bilateralValue != "No") {
                retVal = { inValidBilateralWilling: true };
            }
            return retVal;
        }
        this.bilateralWillingCtrl = new FormControl('', [hasValidBilateralWilling.bind(this)]);
        this.bilateralWillingList = ['Yes', 'No'];

        function hasValidTrail(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidPromoTrail: true };
            }

            return retVal;
        }
        this.promotrailCtrl = new FormControl('', [
            Validators.required,
            hasValidTrail.bind(this)
        ]);
        this.promotrailList = ['Yes', 'No'];
        // this.callTypeList = ['Incoming', 'Outgoing'];


        function hasValidPot(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidPot: true };
            }

            return retVal;
        }
        this.potCtrl = new FormControl('', [
            Validators.required,
            hasValidPot.bind(this)
        ]);
        this.potCusOptList = ['Yes', 'No'];
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidDr(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidDr: true };
            }

            return retVal;
        }
        this.drConsCtrl = new FormControl('', [
            Validators.required,
            hasValidDr.bind(this)
        ]);
        this.drList = ['Yes', 'No'];

        //FOR AUTO COMPLETE VALIDATION --- SESSION/CLASS
        function hasValidSessionClass(input: FormControl) {
            let value = input.value, retVal = null;
            if (value != "Session" && value != "Class") {
                retVal = { inValidSessionClass: true };
            }
            return retVal;
        }
        this.sessionClassCtrl = new FormControl('', [hasValidSessionClass.bind(this)]);
        this.sessionClassList = ['Session', 'Class'];

        this.sessionCountCtrl = new FormControl('', [Validators.min(1)]);

        this.therapyPackageCtrl = new FormControl('');
        this.therapyPackageList = [
            '4 Days',
            '12 Days',
            '20 Days',
            '24 Days'
        ];

        //FOR AUTO COMPLETE VALIDATION --- CLIENT FEEDBACK
        function hasValidClientFeedback(input: FormControl) {
            let feedbackValue = input.value, retVal = null;
            if (feedbackValue && feedbackValue != "Satisfied" && feedbackValue != "Not-Satisfied") {
                retVal = { invalidFeedback: true };
            }
            return retVal;
        }
        this.clientFeedbackCtrl = new FormControl('', [hasValidClientFeedback.bind(this)]);
        this.clientFeedbackList = ['Satisfied', 'Not-Satisfied'];
        //FOR AUTO COMPLETE VALIDATION --- HV FROM TYPE (optional field)
        function hasValidStoreHv(input: FormControl) {
            let storeHvValue = input.value, retVal = null;
            if (storeHvValue && storeHvValue != "BIC" && storeHvValue != "SOA") {
                retVal = { inValidStatus: true };
            }
            return retVal;
        }
        this.store_hvCtrl = new FormControl('', [
            hasValidStoreHv.bind(this)
        ]);
        this.store_hvOptList = ['BIC', 'SOA'];

        //this.clientCtrl = new FormControl();
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());


        //this.referenceCtrl = new FormControl();
        function hasValidRef(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidRef: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidRef: true };
            }
            return retVal;
        }
        this.referenceCtrl = new FormControl('', [
            Validators.required,
            hasValidRef.bind(this)
        ]);
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.getFilteredReferenceList());

        function hasValidRef1(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidRef: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidRef: true };
            }
            return retVal;
        }
        this.referenceCtrl1 = new FormControl('', [
            Validators.required,
            hasValidRef1.bind(this)
        ]);
        this.filteredReference1 = this.referenceCtrl1.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.getFilteredReferenceList());

        function hasValidOldRef(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidOldRef: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidOldRef: true };
            }
            return retVal;
        }
        // Removed Old Reference FormControl - field is now readonly and auto-populated

        function hasValidTestType(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidTestType: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidTestType: true };
            }
            return retVal;
        }
        // this.testingtypeCtrl = new FormControl('', [
        //     Validators.required,
        //     hasValidTestType.bind(this)
        // ]);

        //this.testingtypeCtrl = new FormControl();
        // this.filteredTypes = this.testingtypeCtrl.valueChanges
        //     .startWith(null)
        //     .map(name => name ? this.filterTypes(name) : this.testingList.slice());

        //FOR AUTO COMPLETE VALIDATION -- FOLLOW UP STATUS
        function hasValidFolStatus(input: FormControl) {
            let folStaID = input.value, retVal = null;
            if (folStaID == "") {
                retVal = { inValidFolStatus: true };
            }
            if (folStaID && typeof folStaID === 'string') {
                retVal = { inValidFolStatus: true };
            }
            return retVal;
        }
        this.folStatusCusCtrl = new FormControl('', [
            Validators.required,
            hasValidFolStatus.bind(this)
        ]);

        function hasEmp(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidEMP: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidEMP: true };
            }
            return retVal;
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasEmp.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmp = this.emplistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterEmp(name) : this.empList.slice());

        this.emplistCtrltest = new FormControl('', [
            Validators.required,
            hasEmp.bind(this)
        ]);

        //  this.halistCtrl = new FormControl();
        this.filteredEmptest = this.emplistCtrltest.valueChanges
            .startWith(null)
            .map(name => name ? this.filterEmptest(name) : this.emptestList.slice());

        this.emplistCtrltrail = new FormControl('', [
            // Validators.required,
            hasEmp.bind(this)
        ]);

        //FOR AUTO COMPLETE VALIDATION --- ASSIGN TO LIST
        function hasValidAssignto(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidAssignTo: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidAssignTo: true };
            }
            return retVal;
        }
        this.assignToCtrl = new FormControl('', [
            Validators.required,
            hasValidAssignto.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredEmptrail = this.emplistCtrltrail.valueChanges
            .startWith(null)
            .map(name => name ? this.filterEmptrail(name) : this.emptrailList.slice());

        function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            Validators.required,
            hasSrc.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.filteredStatusList = this.folStatusCusCtrl.valueChanges.startWith(null).map(name => name ? this.filterStatusList(name) : this.statusList.slice());

        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());

        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());

        //Series
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        //Performance
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        //Power
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        //Battery
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));
        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());

        this.octInitiatedByCtrl = new FormControl('');
        this.filteredOctInitiatedBy = this.octInitiatedByCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterOctInitiatedBy(name) : this.octInitiatedByList.slice());
    }


    filterStatusList(name: string) {
        name = _.escapeRegExp(name);
        return this.statusList.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }

    filterBranch(name: string) {
        // console.log("branch searcha",name)
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFun(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    ngOnInit(): void {
        let that = this;
        this.loadComplaint();
        this.loadChallanHaList();
        this.loadEmpList();
        this.loadSrcList();
        this.getStoreUser();
        this.loadPromoTypes();
        this.loadPromoReferences();
        this.loadOctTypeList();

        // Initialize promo field default value for Phone Tracking
        if (this.clientInData && !this.clientInData['promo']) {
            this.clientInData['promo'] = 'No';
        }

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<ClientWalkInModel[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<ClientWalkInModel[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.searchComponent.setType(this._params['tabParams']);

        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            if (this._params['tabParams'] != 'HV Appointment' && this._params['tabParams'] != 'SOA Appointment') {
                this.clientInData['date'] = new Date();
            }
            if (this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment' || this._params['tabParams'] == 'SG Promo' || this._params['tabParams'] == 'DR Promo' || this._params['tabParams'] == 'Store Promo' || this._params['tabParams'] == 'HV Entry' || this._params['tabParams'] == 'SOA Entry') {
                this.clientInData['promo_testing'] = '';
            }

            this.clientInData['promo_date'] = new Date();

            this.searchComponent.clientSearchEmit.subscribe(($e) => {
                that.clientInData['client_id'] = $e['client_id'];
                that.clientInData['client_no'] = $e['client_no'];
                that.clientInData['client_name'] = $e['client_name'];
                //that.clientInData['reference_name'] = $e['reference_name'];
                that.clientInData['reference'] = $e['reference'];
                // that.clientInData['reference_by'] = $e['reference_by'];
                that.singleClientDetails.loadClient($e);//TO LOAD CLIENT OBJECT

                // Auto-populate Old Reference from last walk-in entry
                if (that._params['tabParams'] == 'Client Walk-in' || that._params['tabParams'] == 'HV Entry' || that._params['tabParams'] == 'SOA Entry' || that._params['tabParams'] == 'DR Promo' || that._params['tabParams'] == 'SG Promo' || that._params['tabParams'] == 'Store Promo') {
                    that.loadOldReference($e['client_id']);
                }
                let nextEl = 'status';
                that.onEnterKeyPressed(nextEl);
                // if (_.isEmpty(document.getElementById('status'))) {
                //     nextEl = 'followup_status';
                // }
                // $('#' + this.clientInData['random_no'] + '_' + nextEl).focus();
            });
        }
        if (this._params['tabParams'] == 'Phone Tracking') {
            //this.loadFollowUpStatus();
            this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
                if (_.isEmpty(res.data)) {
                    return;
                }
                this.statusList = _.filter(res.data, function (obj) { return obj['is_phone_tracking'] == 'Yes' });
                this.folStatusCusCtrl.setValue(that.clientInData['followup_status']);
            });
        }
        //this.loadReferenceList();
        //TO LOAD REFERENCE COMBO LIST
        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllReference());
                //this.brandList$ = res;
                return;
            }
            this.itemList = res;
            that.referenceCtrl.setValue(that.clientInData['reference']);
        });

        this.clientInData['random_no'] = this.getRandomInt(1, 500);

        //this.testingtypeCtrl.disable();

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && auth['usertype'] == 'User') {
                this.clientInData['branch_id'] = auth['branch_id'];
                this.branchCtrl.disable();
            }
        });


        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });

        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.user_branch_name = auth['fullname'];
                this.user_branch_type = auth['usertype']; //== 'User'
            }
        });
    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function (res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.clientInData['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.clientInData['family_id']);
            });
    }

    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit' || this._params['tabParams']) {
                if (this._params['test_type_id']) {
                    const pocIds = this._params['test_type_id'].toString();
                    if (pocIds.indexOf(',') > 0) {
                        const pocIdList = pocIds.split(',').map(function (item) {
                            return item;
                        });
                        this._params['poc'] = pocIdList;
                    } else {
                        this._params['poc'] = [pocIds];
                    }
                }
                this.clientInData = this._params;

                // Initialize therapy fields with defaults if not present
                if (!this.clientInData['session_class']) {
                    this.clientInData['session_class'] = '';
                }
                if (!this.clientInData['session_count']) {
                    this.clientInData['session_count'] = 0;
                }
                if (!this.clientInData['therapy_package']) {
                    this.clientInData['therapy_package'] = '';
                }
                if (!this.clientInData['completed_sessions']) {
                    this.clientInData['completed_sessions'] = 0;
                }
                // Initialize from_type field for HV Entry
                if (!this.clientInData['from_type']) {
                    this.clientInData['from_type'] = '';
                }

                // Initialize Client Feedback FormControl for edit mode
                if (this.clientInData['client_feedback']) {
                    this.clientFeedbackCtrl.setValue(this.clientInData['client_feedback']);
                }

                // Initialize promo fields for edit mode
                if (this.clientInData['promo_type_name']) {
                    this.clientInData['promo_type_display'] = this.clientInData['promo_type_name'];
                }
                if (this.clientInData['promo_reference_name']) {
                    this.clientInData['promo_reference_display'] = this.clientInData['promo_reference_name'];
                }
                // Load promo data and set filtered references for edit mode
                if (this.clientInData['promo'] === 'Yes') {
                    this.loadPromoTypes();
                    this.loadPromoReferences();
                    if (this.clientInData['promo_type_id']) {
                        setTimeout(() => {
                            this.filterPromoReferencesByType(this.clientInData['promo_type_id']);
                        }, 500);
                    }
                }

                // Initialize old reference display field for edit mode
                if (this.clientInData['old_reference'] && (this._params['tabParams'] == 'Client Walk-in' || this._params['tabParams'] == 'HV Entry' || this._params['tabParams'] == 'SOA Entry' || this._params['tabParams'] == 'DR Promo' || this._params['tabParams'] == 'SG Promo' || this._params['tabParams'] == 'Store Promo')) {
                    // If we have an old_reference ID, fetch its name to display
                    this.loadOldReferenceDisplayName(this.clientInData['old_reference']);
                }

                // this.clientInData['status'] =  [this._params['status']];
                // this.onSelectedStatus(this.clientInData['status']);
                // this.clientInData['poc'] =  this._params['poc'];

                this.clientInData['date'] = new Date(this._params['date']);//new Date();
                this.clientInData['promo_date'] = new Date(this._params['promo_date']);//new Date();
                this.clientInData['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                this.clientInData['empidtest'] = this._params['testing_attender_name'];
                this.clientInData['empidtrail'] = this._params['trail_attender_name'];
                this.clientInData['srf_no'] = this._params['srf_no'];
                this.clientInData['client_branch_id'] = this._params['client_branch_id'];
                this.clientInData['act_assign_empid'] = this._params['assign_empid'];
                this.clientInData['description'] = this._params['description'];
                if (this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment') {
                    this.clientInData['empidtest'] = this._params['assign_empid'];
                }
                //this.clientInData['model_id'] =  this._params['model_id'];
                this.hasEditDisabled = false;
                if ((this._params['tabParams'] == 'Phone Tracking' || this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment') && this._params['walkin_id']) {

                    this.clientInData['walkin_id'] = this._params['walkin_id'];
                    this.setTransactionEditFlag(this.clientInData['client_id']);
                }

                if (this._params['tabParams'] != 'HV Appointment' || this._params['tabParams'] != 'SOA Appointment') {
                    this.singleClientDetails.loadClient(this.clientInData['client_id']);
                }
                let status = this._params['status'];
                if (status == 'Testing' || status == 'Re-Check up' || status == 'Programing-Others' ||
                    status == 'Re-Program-Others' || status == 'Re-Trial-Testing') {
                    this.loadClientTypeList();
                }
                if ((this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment') && this._params['mode'] == 'Add') {
                    this.clientInData['model_id'] = '';
                } else {
                    if (typeof this._params['model_id'] == "number") {
                        this.clientInData['model_id'] = [this._params['model_id']];
                    } else if (!_.isEmpty(this._params['model_id'])) {
                        let modelIds = this._params['model_id'];
                        if (typeof this._params['model_id'] == "string") {
                            modelIds = this._params['model_id'].split(',').map(function (item) {
                                return parseInt(item);
                            });
                        }

                        this.clientInData['model_id'] = modelIds;
                    }
                }

            }
        }
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    onResetWalkIn() {
        this.resetWalkInData();
        //this.testingtypeCtrl.enable();
    }
    searchClient(query: string) {
        this.searchTerms.next(query);
    }
    onSelectedStatus(status) {
        if (!_.isEmpty(status)) {
            // this.testingtypeCtrl.disable();
            // if (status == 'Testing' || status == 'Trial' ||status == 'Re-Check up' || status == 'Programing-Others' ||
            //     status == 'Re-Program-Others' || status == 'Re-Trial-Testing' || status == 'Programing'
            // ) {
            if (status == 'Testing' || status == 'Re-Check up' || status == 'Programing-Others' ||
                status == 'Re-Program-Others' || status == 'Re-Trial-Testing' || status == 'Programing'
            ) {
                // this.testingtypeCtrl.enable();
                if (_.isEmpty(this.testingList)) {
                    this.loadClientTypeList();
                }
            }
            this.loadPocList(status);
        }
    }
    loadPocList(status) {
        let that = this;
        let data = {
            pov_name: status
        };
        this.pocList = [];
        const pocIds = this.pocCusCtrl.value;
        this.commonService
            .getPocListByPov(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.pocList = res.data;
                    that.pocListArray = res.data;
                    if (pocIds && pocIds.length) {
                        that.pocCusCtrl.setValue(pocIds.filter(pocId => that.pocList.findIndex(poc => poc.id === pocId) < 0));
                    }
                } else {
                    that.pocCusCtrl.setValue([]);
                }
            });
    }
    displayPocFun(pocID: any) {
        if (this.pocList != undefined) {
            if (pocID && this.pocList.length > 0) {
                let fitem = _.find(this.pocList, { 'id': pocID });
                return fitem['name'];
            }
        }
        return '';
    }
    selectStatus(status) {
        if (status == 24) {
            this.service = true;
        } else {
            this.service = false;
        }

        const hasFolAssigneeObj = this.checkFollowupAssignee(status);
        if (status && hasFolAssigneeObj) {
            this.assign = true;
        } else {
            this.assign = false;
        }
    }

    // CHECK FOLLOWUP ASIGNEE
    checkFollowupAssignee(status) {
        const folAssigneeObj = _.find(this.statusList, function (obj) { return obj['fol_id'] == status && obj['is_phone_tracking'] == 'Yes' && obj['is_phone_tracking_asignee'] == 'Yes' });
        return folAssigneeObj ? true : false;
    }
    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.clientInData['random_no'] + '_' + nextEl))) {
            if (nextEl == 'to_whom') {
                nextEl = 'call_by';
            } else {
                nextEl = 'followup_status';
            }
        } else if (this.clientInData['status'] != 'Testing' && this.clientInData['status'] != 'Re-Check up' && nextEl == 'testingtype_obj') {
            nextEl = 'description';
        }
        $('#' + this.clientInData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.clientInData['client_name'] = fitem.client_name; //ANOTHER FIELD
                this.clientInData['reference_name'] = fitem.reference_name;
                this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }
        }
        return '';
    }

    displayType(type_id: number) {
        if (type_id && this.testingList.length > 0) {
            let ftype = _.find(this.testingList, { 'id': type_id });
            return ftype['name'];
        }
        return '';
    }

    filterTypes(name: string) {
        name = _.escapeRegExp(name);
        return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name)));
    }

    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayBrandModelFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.clientInData['disp_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //brnach
    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let branchObj = _.find(this.branchList, { 'branch_id': parseInt(branchID.toString()) });
            return branchObj['branch_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.clientInData['name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            this.clientInData['family_name'] = fitem['family_name'];
            return fitem['family_name'];
        }
        return '';
    }

    onChangeFamily() {
        this.loadFamilyList();
        this.loadAllList();
    }

    //Series
    filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            this.clientInData['series_name'] = seriesitem['series_name'];
            return seriesitem['series_name'];
        }
        return '';
    }

    //Performance
    filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            this.clientInData['performance_name'] = performanceitem['performance_name'];
            return performanceitem['performance_name'];
        }
        return '';
    }

    //Power
    filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            this.clientInData['power_name'] = poweritem['power_name'];
            return poweritem['power_name'];
        }
        return '';
    }

    //Battery
    filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            this.clientInData['battery_name'] = batteryitem['battery_name'];
            return batteryitem['battery_name'];
        }
        return '';
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function (res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.clientInData['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.clientInData['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.clientInData['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.clientInData['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.clientInData['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.clientInData['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.clientInData['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.clientInData['battery_id']);

            });
    }


    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.clientInData = [];
            this.clientInData['date'] = new Date();
            this.clientInData['session_class'] = '';
            this.clientInData['session_count'] = 0;
            this.clientInData['therapy_package'] = '';
            this.clientInData['completed_sessions'] = 0;
        }
    }
    // loadFollowUpStatus(): void {
    //     let that = this;
    //
    //     // that.commonService
    //     //     .getFollowUpStatusList({})
    //     //     .then(function(res: any) {
    //     //         that.statusList = res.data;
    //     //     });
    // }
    loadClientTypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function (res: any) {
                that.testingList = res;
                // that.testingtypeCtrl.setValue(that.clientInData['testing_id']);
            });
    }

    getStoreUser() {
        let that = this;
        that.commonService
            .getStoreUserList()
            .then(function (res: any) {
                that.storeUserList = res.data;
            });
    }

    filteredAssignList(): any[] {
        let name = this.assignToCtrl.value;
        if (!name) {
            return this.assignToList || []; // Ensure it returns an array
        }
        let filterValue = typeof name === 'string' ? name.toLowerCase() : '';
        return (this.assignToList || []).filter(emp => emp.fullname.toLowerCase().includes(filterValue));
    }

    assignFn(empid: any) {
        if (this.assignToList != undefined) {
            if (empid && this.assignToList.length > 0) {
                let fitem = _.find(this.assignToList, { 'userid': empid });
                return fitem['fullname'];
            }
        }
        return '';
    }

    displayStatusFn(fol_id: any) {
        let that = this;
        that.clientInData['assign_empid'] = "";
        if (fol_id && this.checkFollowupAssignee(fol_id)) {
            let data = {
                fol_id: fol_id
            };

            that.commonService
                .getUserList(data)
                .then(function (res: any) {
                    if (that.user_branch_type == 'User') {
                        that.storeUserList = _.filter(that.storeUserList, function (obj) { return obj['fullname'] == that.user_branch_name });
                    }
                    // console.log("assignToList",res.data);
                    // console.log("storeUserList",that.storeUserList);
                    that.assignToList = res.data;
                    // Merge the arrays using the spread operator
                    that.assignToList = [...that.storeUserList, ...that.assignToList];
                    // Remove duplicates while preserving order
                    that.assignToList = that.assignToList.filter(
                        (value, index, self) =>
                            index === self.findIndex((v) => v.userid === value.userid)
                    );
                    if (that._params['mode'] == 'Edit') {
                        that.assignToCtrl.setValue(that._params['act_assign_empid']);
                    }
                });
        } else {
            if (that.user_branch_type == 'User') {
                that.storeUserList = _.filter(that.storeUserList, function (obj) { return obj['fullname'] == that.user_branch_name });
            }
            that.assignToList = that.storeUserList;
            if (that._params['mode'] == 'Edit') {
                that.assignToCtrl.setValue(that._params['act_assign_empid']);
            }
        }
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }

    // loadReferenceList() {
    //     // let that = this;
    //     // this.commonService
    //     //     .getReferenceList()
    //     //     .then(function(res: any) {
    //     //         that.itemList = res;
    //     //         that.referenceCtrl.setValue(that.clientInData['reference']);
    //     //         /*if (that.mode == "Edit") {
    //     //             that.brandCtrl.disable();
    //     //             $('#name').focus();
    //     //         }*/
    //     //     });
    // }

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        const baseList = this.getFilteredReferenceList();
        return baseList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    /**
     * Get filtered reference list based on tab type
     * For DR Promo, only show references with reference_type='Doctor'
     */
    getFilteredReferenceList() {
        if (this._params && this._params['tabParams'] === 'DR Promo') {
            return this.itemList.filter(item => item.reference_type === 'Doctor');
        }
        return this.itemList.slice();
    }

    filterStatusItems(name: string) {
        name = _.escapeRegExp(name);
        return this.statusList.filter(item => (new RegExp(name, 'gi').test(item)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            if (fitem) {
                this.clientInData['ref_name'] = fitem.name;
                return fitem['name'];
            }
        }
        return '';
    }

    // Removed displayOldRef - Old Reference is now readonly and auto-populated

    loadEmpList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.empList = res['data'];
                that.emptestList = res['data'];
                that.emptrailList = res['data'];
                that.octInitiatedByList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.emplistCtrl.setValue(that.clientInData['empid']);
                that.emplistCtrltest.setValue(that.clientInData['empidtest']);
                that.emplistCtrltrail.setValue(that.clientInData['empidtrail']);
                that.octInitiatedByCtrl.setValue(that.clientInData['oct_initiated_by']);
                if (that.clientInData['oct_initiated_by']) {
                    that.octInitiatedByCtrl.disable();
                }
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

    filterEmp(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.empList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    displayEmp(item_id: number) {

        if (item_id && this.empList.length > 0) {
            let fhalist = _.find(this.empList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }

    filterEmptest(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.emptestList.filter(ha => (new RegExp(empname, 'gi').test(ha.empidtest)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    displayEmptest(item_id: number) {

        if (item_id && this.empList.length > 0) {
            let fhalist = _.find(this.emptestList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }

    filterEmptrail(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.emptrailList.filter(ha => (new RegExp(empname, 'gi').test(ha.empidtrail)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }

    displayEmptrail(item_id: number) {

        if (item_id && this.emptrailList.length > 0) {
            let fhalist = _.find(this.emptrailList, { 'empid': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['empname'];
        }
        return '';
    }

    loadSrcList() {
        let that = this,
            data = {
                name: ''
            };
        this.commonService
            .getSourceName(data)
            .then(function (res: any) {
                that.srcList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.srclistCtrl.setValue(that.clientInData['source_id']);
                //that.srclistCtrl.setValue(that.clientInData['source_name']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

    filterSrc(source_name: string) {
        source_name = _.escapeRegExp(source_name);
        return this.srcList.filter(ha => (new RegExp(source_name, 'gi').test(ha.source_id)
            || new RegExp(source_name, 'gi').test(ha.source_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'source_id': item_id }),
                source_name = fhalist.source_name;
            this.clientInData['source_name'] = source_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['source_name'];
        }
        return '';
    }

    loadChallanHaList() {
        let that = this,
            data = {
                stock_type: 'HA MODEL'
            };
        this.commonService
            .getHaModelTrailStock(data)
            .then(function (res: any) {
                that.haList = res['haStockModel'];
                that.additionhaList = res['haStockModel'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.clientInData['model_id']);
            });
    }

    loadComplaint() {
        let that = this;
        this.commonService
            .getComplaintList()
            .then(function (res: any) {
                that.complaintList = res;
                that.allComplaintList = res;
            });
    }

    displayOctTypeFn(octId: any): string {
        if (octId && this.octTypeList && this.octTypeList.length > 0) {
            let fitem = _.find(this.octTypeList, { 'id': Number(octId) });
            if (fitem) return fitem['name'];
        }
        return '';
    }

    loadOctTypeList() {
        let that = this;
        this.octTypeService.getOctTypeList({ start: 0, limit: 1000, orderColumn: 'name', orderDir: 'asc' })
            .then(function (res: any) {
                that.octTypeList = (res.data || []).filter((o: any) => o.status === 'Active');
                if (that.clientInData && that.clientInData['oct_type_id']) {
                    let val = that.clientInData['oct_type_id'];
                    that.clientInData['oct_type_id'] = null;
                    setTimeout(() => { that.clientInData['oct_type_id'] = val; }, 0);
                }
            });
    }

    filterOctInitiatedBy(name: string) {
        name = _.escapeRegExp(name);
        return this.octInitiatedByList.filter(emp => (new RegExp(name, 'gi').test(emp.empid)
            || new RegExp(name, 'gi').test(emp.empname)));
    }

    displayOctInitiatedByFn(empID: any) {
        if (empID && this.octInitiatedByList.length > 0) {
            let fitem = _.find(this.octInitiatedByList, { 'empid': empID });
            if (fitem) {
                this.clientInData['oct_initiated_by'] = empID;
                return fitem['empname'];
            }
        }
        return '';
    }

    //COMPLAINT LIST SEARCH
    searchComplaintList(term: string) {
        if (term) {
            this.complaintList = this.allComplaintList.filter((data) => new RegExp(term, 'gi').test(data.comp_name));
        } else {
            this.complaintList = this.allComplaintList;
        }
    }

    bsModalRef: BsModalRef;
    onLoadMachineDetails() {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        if (this.clientInData['model_id'] == '' || this.clientInData['model_id'] == undefined) {
            toast['body'] = 'Please Select Model';
            this.toasterService.pop(toast);
            return;
        }
        let data = {
            model_id: this.clientInData['model_id'],
        }


        this.bsModalRef = this.modalService.show(trailModelDetComponent, {
            keyboard: false,
            class: 'modal-lg maxWidthPer-50'
        });
        this.bsModalRef.content.showModelHistory = data;
    }

    // searchTrailList(term: string): void {
    //     if (term) {
    //         this.haList = this.additionhaList.filter((item) => new RegExp(term, 'gi').test(item.name));
    //         console.log(this.haList);

    //         if (this.haList.length) {
    //             fromEvent(this.input.nativeElement, "keyup").debounceTime(1000).delay(200).subscribe((res) => {
    //                 setTimeout(() => {
    //                     this.matSelect.options.map((res,
    //                         index) => {
    //                         let element = res._getHostElement(); if (index === 0) {
    //                             element.classList.add("mat-active")
    //                         } else {
    //                             element.classList.remove("mat-active")
    //                         }
    //                     });
    //                 },
    //                     100);

    //                 setTimeout(() => {
    //                     let element = document.querySelectorAll(".mat-select-panel");
    //                     element[0].scrollTo(0, 0);
    //                     let inputelement = this.render.selectRootElement(this.input.nativeElement);
    //                     // console.log(inputelement);
    //                     inputelement.focus();
    //                 },
    //                     500);
    //             })

    //         }


    //         //     this.input.nativeElement.focus();

    //         // setTimeout(() => {

    //         // }, 100);
    //         // this.input.nativeElement.focus();
    //     } else {
    //         this.haList = this.additionhaList
    //     }


    //     // let panel: any = document.querySelectorAll(".mat-select-panel");
    //     // panel[0].style.top = "0px";
    //     // this.haList = this.additionhaList.filter(item => item.name.toLoweCase().includes(term.toLowerCase()));
    //     // console.log("tremremer", this.haList, this.additionhaList);
    //     // document.getElementById('inSearch').focus(); 
    // }

    searchTrailList(term: string): void {
        if (term) {
            this.haList = this.additionhaList.filter((item) => new RegExp(term, 'gi').test(item.name));
            setTimeout(() => {
                document.getElementById("inSearch").focus();
            }, 200);
        } else {
            this.haList = this.additionhaList;
        }
    }

    storeModaleId(value: any) {
        if (!this.modelStrList.some((item: any) => item === value)) {
            this.modelStrList.push(value);
            let brandName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.brand_name;
                }
            }).filter((el) => el !== undefined);

            let brandModelName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.brand_model_name;
                }
            }).filter((el) => el !== undefined);

            let familyName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.family_name;
                }
            }).filter((el) => el !== undefined);

            let SeriesName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.series_name;
                }
            }).filter((el) => el !== undefined);

            let PerformanceName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.performance_name;
                }
            }).filter((el) => el !== undefined);

            let powerName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.power_name;
                }
            }).filter((el) => el !== undefined);

            let batteryName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.battery_name;
                }
            }).filter((el) => el !== undefined);

            let colorName = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.color_name;
                }
            }).filter((el) => el !== undefined);

            let colorId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.color_id;
                }
            }).filter((el) => el !== undefined);

            let teleAudiology = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.tele_audiology;
                }
            }).filter((el) => el !== undefined);

            let brandId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.brand_id;
                }
            }).filter((el) => el !== undefined);

            let brandModelId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.brand_model_id;
                }
            }).filter((el) => el !== undefined);

            let familyId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.family_id;
                }
            }).filter((el) => el !== undefined);

            let SeriesId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.series_id;
                }
            }).filter((el) => el !== undefined);

            let PerformanceId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.performance_id;
                }
            }).filter((el) => el !== undefined);

            let powerId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.power_id;
                }
            }).filter((el) => el !== undefined);

            let batteryId = this.haList.map((el) => {
                if (el.model_id == value) {
                    return el.battery_id;
                }
            }).filter((el) => el !== undefined);

            this.brandList.push(brandName);
            this.brandModelList.push(brandModelName);
            this.familyList.push(familyName);
            this.seriesList.push(SeriesName);
            this.performanceList.push(PerformanceName);
            this.powerList.push(powerName);
            this.batteryList.push(batteryName);
            this.colorList.push(colorName);
            this.teleAudiologyList.push(teleAudiology);

            this.brandIdList.push(brandId);
            this.brandModelIdList.push(brandModelId);
            this.familyIdList.push(familyId);
            this.seriesIdList.push(SeriesId);
            this.performanceIdList.push(PerformanceId);
            this.powerIdList.push(powerId);
            this.batteryIdList.push(batteryId);
            this.colorIdList.push(colorId);
        } else {
            const index = this.modelStrList.findIndex((item: any) => item === value);
            this.modelStrList.splice(index, 1);
            this.brandList.splice(index, 1);
            this.brandModelList.splice(index, 1);
            this.familyList.splice(index, 1);
            this.seriesList.splice(index, 1);
            this.performanceList.splice(index, 1);
            this.powerList.splice(index, 1);
            this.batteryList.splice(index, 1);
            this.colorList.splice(index, 1);
            this.teleAudiologyList.splice(index, 1);
            this.brandIdList.splice(index, 1);
            this.brandModelIdList.splice(index, 1);
            this.familyIdList.splice(index, 1);
            this.seriesIdList.splice(index, 1);
            this.performanceIdList.splice(index, 1);
            this.powerIdList.splice(index, 1);
            this.batteryIdList.splice(index, 1);
            this.colorIdList.splice(index, 1);
        }
        let str = JSON.stringify(this.modelStrList);
        let brand_str = JSON.stringify(this.brandList);
        let brand_model_str = JSON.stringify(this.brandModelList);
        let family_str = JSON.stringify(this.familyList);
        let series_str = JSON.stringify(this.seriesList);
        let performance_str = JSON.stringify(this.performanceList);
        let power_str = JSON.stringify(this.powerList);
        let battery_str = JSON.stringify(this.batteryList);
        let color_str = JSON.stringify(this.colorList);
        let tele_audiology_str = JSON.stringify(this.teleAudiologyList);
        let brandId_str = JSON.stringify(this.brandIdList);
        let brand_modelId_str = JSON.stringify(this.brandModelIdList);
        let familyId_str = JSON.stringify(this.familyIdList);
        let seriesId_str = JSON.stringify(this.seriesIdList);
        let performanceId_str = JSON.stringify(this.performanceIdList);
        let powerId_str = JSON.stringify(this.powerIdList);
        let batteryId_str = JSON.stringify(this.batteryIdList);
        let colorId_str = JSON.stringify(this.colorIdList);
        this.clientInData['model_id'] = JSON.parse(str);
        this.clientInData['brand_name'] = JSON.parse(brand_str);
        this.clientInData['brand_model_name'] = JSON.parse(brand_model_str);
        this.clientInData['family_name'] = JSON.parse(family_str);
        this.clientInData['series_name'] = JSON.parse(series_str);
        this.clientInData['performance_name'] = JSON.parse(performance_str);
        this.clientInData['power_name'] = JSON.parse(power_str);
        this.clientInData['battery_name'] = JSON.parse(battery_str);
        this.clientInData['color_name'] = JSON.parse(color_str);
        this.clientInData['tele_audiology'] = JSON.parse(tele_audiology_str);
        this.clientInData['brand_id'] = JSON.parse(brandId_str);
        this.clientInData['brand_model_id'] = JSON.parse(brand_modelId_str);
        this.clientInData['family_id'] = JSON.parse(familyId_str);
        this.clientInData['series_id'] = JSON.parse(seriesId_str);
        this.clientInData['performance_id'] = JSON.parse(performanceId_str);
        this.clientInData['power_id'] = JSON.parse(powerId_str);
        this.clientInData['battery_id'] = JSON.parse(batteryId_str);
        this.clientInData['color_id'] = JSON.parse(colorId_str);
    }

    // FOR POC FIELD SEARCH
    searchPocList(term: string): void {
        if (term) {
            this.pocList = this.pocListArray.filter((item) => new RegExp(term, 'gi').test(item.name));
            setTimeout(() => {
                document.getElementById("pocField").focus();
            }, 200);
        } else {
            this.pocList = this.pocListArray;
        }
    }

    storePOCId(value: any) {
        if (!this.pocStrList.some((item: any) => item === value)) {
            this.pocStrList.push(value);
        } else {
            const indexone = this.pocStrList.findIndex((item: any) => item === value);
            this.pocStrList.splice(indexone, 1);
        }
        let str = JSON.stringify(this.pocStrList)
        this.clientInData['poc'] = JSON.parse(str);
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id)
            || new RegExp(name, 'gi').test(ha.name)));
    }

    onSaveWalkIn() {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        if (this._params['tabParams'] == 'Phone Tracking') {
            if (this.clientInData['followup_status'] == 1 || this.clientInData['followup_status'] == 2 || this.clientInData['followup_status'] == 9 || this.clientInData['followup_status'] == 27 || this.clientInData['followup_status'] == 10) {
                if (this.clientInData['assign_empid'] == "" || this.clientInData['assign_empid'] == null || this.clientInData['assign_empid'] == undefined) {
                    toast['body'] = 'Please Select Valid Assign To';
                    this.toasterService.pop(toast);
                    return;
                }
            }
        }
        // if (_.isEmpty(_.toString(this.clientInData['branch_id']))) {
        //     toast['body'] = 'Please Select Branch';
        //     this.toasterService.pop(toast);
        //     return;
        // }

        if (_.isEmpty(_.toString(this.clientInData['client_id']))) {
            toast['body'] = 'Please Select Client';
            this.toasterService.pop(toast);
            return;
        }
        if (this._params['tabParams'] == 'Client Walk-in') {
            if (_.isEmpty(this.clientInData['status'])) {
                toast['body'] = 'Please Select Status ';
                this.toasterService.pop(toast);
                return;
            }
            if (_.isEmpty(this.clientInData['poc'])) {
                toast['body'] = 'Please Select POC ';
                this.toasterService.pop(toast);
                return;
            }
            // if (this.clientInData['status'] == 'Testing' || this.clientInData['status'] == 'Re-Check up') {
            //     if (this.testingtypeCtrl['status'] != 'VALID') {
            //         toast['body'] = 'Please Select Valid Testing Type';
            //         this.toasterService.pop(toast);
            //         return;
            //     }
            // }
        } else {
            if (_.isEmpty(_.toString(this.clientInData['followup_status']))) {
                toast['body'] = 'Please Select Status ';
                this.toasterService.pop(toast);
                return;
            }
        }

        if (_.isEmpty(_.toString(this.clientInData['reference']))) {
            toast['body'] = 'Please Select Reference';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(this.clientInData['srf_no'])) && this.clientInData['followup_status'] == 24) {
            toast['body'] = 'Please Select SRF Number';
            this.toasterService.pop(toast);
            $('#' + 'service').focus();
            return;
        }

        //  if (_.isEmpty(_.toString(this.clientInData['client_branch_id']))) {
        //     toast['body'] = 'Please Select Branch';
        //     this.toasterService.pop(toast);
        //     return;
        // }

        if (this.clientInData['status'] == 'Programing') {
            this.clientInData['bill_gen'] = 'Yes';
        }
        let that = this,
            walkInDate = moment(this.clientInData['date']).format('YYYY-MM-DD'),
            data = {
                walkin_id: this.clientInData['walkin_id'],
                client_id: this.clientInData['client_id'],
                client_name: this.clientInData['client_name'],
                date: walkInDate,
                potential_customer: this.clientInData['potential_customer'],
                status: this.clientInData['status'],
                poc: this.clientInData['poc'],
                walk_in_type: this.clientInData['walk_in_type'],
                store_promo: this.clientInData['store_promo'],
                store_promo_ref: this.clientInData['store_promo_ref'],
                cus_connect: this.clientInData['cus_connect'],
                cus_connect_ref: this.clientInData['cus_connect_ref'],
                mode: this._params['mode'],
                page_type: this._params['tabParams'],
                followup_status: this.clientInData['followup_status'],
                description: this.clientInData['description'],
                reference: this.clientInData['reference'],
                ref_name: this.clientInData['ref_name'],
                // reference_by: this.clientInData['reference_by'],
                testing_id: this.clientInData['testing_id'],
                remarks_by: this.clientInData['empid'],
                source_id: this.clientInData['source_id'],
                source_name: this.clientInData['source_name'],
                call_by: this.clientInData['call_by'],
                call_number: this.clientInData['call_number'],
                to_whom: this.clientInData['to_whom'],
                ha_user: this.clientInData['ha_user'],
                dr_consulted: this.clientInData['dr_consulted'],
                srf_no: this.clientInData['srf_no'],
                assign_empid: this.clientInData['assign_empid'],
                bill_gen: this.clientInData['bill_gen'],
                trail_att: this.clientInData['empidtrail'],
                client_feedback: this.clientInData['client_feedback'],
                call_type: this.clientInData['call_type'],
                hasEditDisabled: this.hasEditDisabled,
                st_det_id: this.clientInData['st_det_id'],
                client_branch_id: this.clientInData['client_branch_id'],
                branch_id: this.clientInData['branch_id'],
                session_class: this.clientInData['session_class'],
                session_count: this.clientInData['session_count'],
                therapy_package: this.clientInData['therapy_package'],
                completed_sessions: this.clientInData['completed_sessions'],
                // New fields for promo functionality
                promo: this.clientInData['promo'],
                promo_type_id: this.clientInData['promo_type_id'],
                promo_reference_id: this.clientInData['promo_reference_id'],
                promo_reference_details: this.clientInData['promo_reference_details'],
                // New fields for old reference and doctor type
                old_reference: this.clientInData['old_reference'],
                doctor_type: this.clientInData['doctor_type'],
                oct_type_id: this.clientInData['oct_type_id'] || '',
                oct_initiated_by: this.clientInData['oct_initiated_by'] || ''
            };
        this.isLoading = true;
        this.clientWalkInService
            .addUpdateWalkIn(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.resetWalkInData();
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadClientWalkInGrid();

                } else if (res.pending) {
                    swal('SENT FOR APPROVAL', res.message, 'info');
                    that.resetWalkInData();
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

    onSaveWalkInPromo() {
        let that = this,
            promoDate = moment(this.clientInData['promo_date']).format('YYYY-MM-DD'),
            model_id = '',
            reference1 = '',
            brand_id = 0,
            brand_model_id = 0,
            family_id = 0,
            series_id = 0,
            performance_id = 0,
            power_id = 0,
            branch_id = '',
            battery_id = 0,
            color_id = 0;
        if (that.clientInData['model_id'] != undefined) {
            model_id = (that.clientInData['model_id']).join();
        };
        if (that.clientInData['reference1'] != undefined) {
            reference1 = that.clientInData['reference1'];
        }
        if (this.clientInData['promo_testing'] == 'No') {
            this.clientInData['testing_desc'] = '';
            this.clientInData['diagnosis_left'] = '';
            this.clientInData['diagnosis_right'] = '';
        }
        let data = {
            walkin_id: this.clientInData['walkin_id'],
            client_id: this.clientInData['client_id'],
            client_name: this.clientInData['client_name'],
            date: promoDate,
            mode: this._params['mode'],
            page_type: this._params['tabParams'],
            promo_testing: this.clientInData['promo_testing'],
            description: this.clientInData['description'],
            potential_customer: this.clientInData['potential_customer'],
            reference: this.clientInData['reference'],
            travel_expense: this.clientInData['travel_expense'],
            bill_gen: this.clientInData['bill_gen'],
            test_att: this.clientInData['empidtest'],
            trail_att: this.clientInData['empidtrail'],
            promo_trail: this.clientInData['promo_trail'],
            ost_done: this.clientInData['ost_done'] ? this.clientInData['ost_done'] : '',
            bilateral_willing_client: this.clientInData['bilateral_willing_client'] ? this.clientInData['bilateral_willing_client'] : '',
            model_id: model_id,
            reference1: reference1,
            branch_id: this.clientInData['branch_id'],
            testing_desc: this.clientInData['testing_desc'] ? this.clientInData['testing_desc'] : '',
            diagnosis_left: this.clientInData['diagnosis_left'] ? this.clientInData['diagnosis_left'] : '',
            diagnosis_right: this.clientInData['diagnosis_right'] ? this.clientInData['diagnosis_right'] : '',
            client_feedback: this.clientInData['client_feedback'],
            from_type: this.clientInData['from_type'] ? this.clientInData['from_type'] : '',
            // Promo fields for SG Promo, DR Promo, HV Entry, SOA Entry
            promo: this.clientInData['promo'],
            promo_type_id: this.clientInData['promo_type_id'],
            promo_reference_id: this.clientInData['promo_reference_id'],
            promo_reference_details: this.clientInData['promo_reference_details'],
            old_reference: this.clientInData['old_reference'],
            doctor_type: this.clientInData['doctor_type'],
            oct_type_id: this.clientInData['oct_type_id'] || '',
            oct_initiated_by: this.clientInData['oct_initiated_by'] || ''
        };
        if (this._params['tabParams'] == 'SG Promo' || this._params['tabParams'] == 'DR Promo' || this._params['tabParams'] == 'Store Promo' || this._params['tabParams'] == 'HV Entry' || this._params['tabParams'] == 'HV Appointment' || this._params['tabParams'] == 'SOA Appointment' || this._params['tabParams'] == 'SOA Entry') {
            data['status'] = this.clientInData['status'];
            data['poc'] = this.clientInData['poc'];
            if (this._params['mode'] == 'Add') {
                if (that.clientInData['brand_id'] != undefined) {
                    brand_id = (that.clientInData['brand_id']).join();
                };
                if (that.clientInData['brand_model_id'] != undefined) {
                    brand_model_id = (that.clientInData['brand_model_id']).join();
                };
                if (that.clientInData['family_id'] != undefined) {
                    family_id = (that.clientInData['family_id']).join();
                };
                if (that.clientInData['series_id'] != undefined) {
                    series_id = (that.clientInData['series_id']).join();
                };
                if (that.clientInData['performance_id'] != undefined) {
                    performance_id = (that.clientInData['performance_id']).join();
                };
                if (that.clientInData['power_id'] != undefined) {
                    power_id = (that.clientInData['power_id']).join();
                };
                if (that.clientInData['battery_id'] != undefined) {
                    battery_id = (that.clientInData['battery_id']).join();
                };
                if (that.clientInData['color_id'] != undefined) {
                    color_id = (that.clientInData['color_id']).join();
                };
            } else {
                if (that.clientInData['brand_id'] != undefined) {
                    brand_id = that.clientInData['brand_id'];
                };
                if (that.clientInData['brand_model_id'] != undefined) {
                    brand_model_id = that.clientInData['brand_model_id'];
                };
                if (that.clientInData['family_id'] != undefined) {
                    family_id = that.clientInData['family_id'];
                };
                if (that.clientInData['series_id'] != undefined) {
                    series_id = that.clientInData['series_id'];
                };
                if (that.clientInData['performance_id'] != undefined) {
                    performance_id = that.clientInData['performance_id'];
                };
                if (that.clientInData['power_id'] != undefined) {
                    power_id = that.clientInData['power_id'];
                };
                if (that.clientInData['battery_id'] != undefined) {
                    battery_id = that.clientInData['battery_id'];
                };
                if (that.clientInData['color_id'] != undefined) {
                    color_id = that.clientInData['color_id'];
                };
            }

            data['brand_id'] = brand_id;
            data['brand_model_id'] = brand_model_id;
            data['family_id'] = family_id;
            data['series_id'] = series_id;
            data['performance_id'] = performance_id;
            data['power_id'] = power_id;
            data['battery_id'] = battery_id;
            data['color_id'] = color_id;

        }

        this.isLoading = true;
        this.clientWalkInService
            .addUpdateWalkInPromo(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.resetWalkInData();
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadClientWalkInGrid();
                    if (that._params['page_from'] == 'HV Entry' || that._params['page_from'] == 'SOA Entry') {
                        that.subscribeService.subReloadClientWalkInGrid();
                    }

                } else if (res.pending) {
                    swal('SENT FOR APPROVAL', res.message, 'info');
                    that.resetWalkInData();
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
            });
    }

    onSaveHVSOAAppointment() {
        let that = this,
            haDate = moment(this.clientInData['date']).format('YYYY-MM-DD'),
            model_id = '',
            brand_id = 0,
            brand_model_id = 0,
            family_id = 0,
            series_id = 0,
            performance_id = 0,
            power_id = 0,
            battery_id = 0,
            color_id = 0;
        if (that.clientInData['model_id'] != undefined && that.clientInData['model_id'] != "") {
            model_id = (that.clientInData['model_id']).join();
        };

        let data = {
            ha_id: this.clientInData['ha_id'],
            walkin_id: this.clientInData['walkin_id'],
            client_id: this.clientInData['client_id'],
            client_name: this.clientInData['client_name'],
            st_id: this.clientInData['st_id'],
            st_det_id: this.clientInData['st_det_id'],
            date: haDate,
            mode: this._params['mode'],
            travel_expense: this._params['travel_expense'],
            // mode: 'Add',
            // page_type: this._params['tabParams'],
            page_type: this._params['pageType'],
            promo_testing: this.clientInData['promo_testing'],
            description: this.clientInData['description'],
            potential_customer: this.clientInData['potential_customer'],
            reference: this.clientInData['reference'],
            bill_gen: this.clientInData['bill_gen'],
            test_att: this.clientInData['empidtest'],
            trail_att: this.clientInData['empidtrail'],
            promo_trail: this.clientInData['promo_trail'],
            ost_done: this.clientInData['ost_done'] ? this.clientInData['ost_done'] : '',
            bilateral_willing_client: this.clientInData['bilateral_willing_client'] ? this.clientInData['bilateral_willing_client'] : '',
            model_id: model_id,
            hv_status: this.clientInData['hv_status'],
            status: this.clientInData['status'],
            pov: this.clientInData['status'],
            poc: this.clientInData['poc'],
            testing_desc: this.clientInData['testing_desc'] ? this.clientInData['testing_desc'] : '',
            diagnosis_left: this.clientInData['diagnosis_left'] ? this.clientInData['diagnosis_left'] : '',
            diagnosis_right: this.clientInData['diagnosis_right'] ? this.clientInData['diagnosis_right'] : '',
            branch_id: this.clientInData['branch_id'],
            client_feedback: this.clientInData['client_feedback'],
            from_type: this.clientInData['from_type'] ? this.clientInData['from_type'] : '',
            oct_type_id: this.clientInData['oct_type_id'] || '',
            oct_initiated_by: this.clientInData['oct_initiated_by'] || ''
        };
        if (this._params['mode'] == 'Add') {
            if (that.clientInData['brand_id'] != undefined) {
                brand_id = (that.clientInData['brand_id']).join();
            };
            if (that.clientInData['brand_model_id'] != undefined) {
                brand_model_id = (that.clientInData['brand_model_id']).join();
            };
            if (that.clientInData['family_id'] != undefined) {
                family_id = (that.clientInData['family_id']).join();
            };
            if (that.clientInData['series_id'] != undefined) {
                series_id = (that.clientInData['series_id']).join();
            };
            if (that.clientInData['performance_id'] != undefined) {
                performance_id = (that.clientInData['performance_id']).join();
            };
            if (that.clientInData['power_id'] != undefined) {
                power_id = (that.clientInData['power_id']).join();
            };
            if (that.clientInData['battery_id'] != undefined) {
                battery_id = (that.clientInData['battery_id']).join();
            };
            if (that.clientInData['color_id'] != undefined) {
                color_id = (that.clientInData['color_id']).join();
            };
        } else {
            if (that.clientInData['brand_id'] != undefined) {
                brand_id = that.clientInData['brand_id'];
            };
            if (that.clientInData['brand_model_id'] != undefined) {
                brand_model_id = that.clientInData['brand_model_id'];
            };
            if (that.clientInData['family_id'] != undefined) {
                family_id = that.clientInData['family_id'];
            };
            if (that.clientInData['series_id'] != undefined) {
                series_id = that.clientInData['series_id'];
            };
            if (that.clientInData['performance_id'] != undefined) {
                performance_id = that.clientInData['performance_id'];
            };
            if (that.clientInData['power_id'] != undefined) {
                power_id = that.clientInData['power_id'];
            };
            if (that.clientInData['battery_id'] != undefined) {
                battery_id = that.clientInData['battery_id'];
            };
            if (that.clientInData['color_id'] != undefined) {
                color_id = that.clientInData['color_id'];
            };
        }

        data['brand_id'] = brand_id;
        data['brand_model_id'] = brand_model_id;
        data['family_id'] = family_id;
        data['series_id'] = series_id;
        data['performance_id'] = performance_id;
        data['power_id'] = power_id;
        data['battery_id'] = battery_id;
        data['color_id'] = color_id;

        this.isLoading = true;
        this.clientWalkInService
            .addUpdateHVSOAAppointment(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal(
                        'SUCCESS',
                        res.message,
                        'success'
                    );
                    that.resetWalkInData();
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadAppointmentGrid();

                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
            });
    }
    showRef() {
        if (this.clientInData['reference'] == 9) {
            this.showReference = true;
        } else {
            this.showReference = false;
        }
    }

    // Removed showOldRef - Old Reference is now readonly and auto-populated

    setTransactionEditFlag(client_id) {
        let that = this,
            params = {
                client_id: client_id
            };
        this.clientWalkInService
            .getLatestWalkInDetails(params)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    let resData = res.data[0];
                    that.clientInData['last_walkin_date'] = new Date(resData.last_walkin_date);
                    if (resData.last_trans_status != 'Phone Tracking' && resData.last_followup_date) {
                        that.clientInData['last_followup_date'] = new Date(resData.last_followup_date);
                        that.hasEditDisabled = that.clientInData['date'] < that.clientInData['last_followup_date'];
                    } else {
                        that.hasEditDisabled = that.clientInData['date'] < that.clientInData['last_walkin_date'];
                    }
                }
            });
    }

    isPovOct(): boolean {
        if (!this.clientInData['status']) { return false; }
        let status = this.clientInData['status'];
        if (Array.isArray(status)) { return status.some(s => s && s.toUpperCase() === 'OCT'); }
        if (typeof status === 'string') { return status.toUpperCase() === 'OCT'; }
        return false;
    }

    isPovTrail(): boolean {
        if (!this.clientInData['status']) {
            return false;
        }

        let status = this.clientInData['status'];

        // Handle array (multiple selection)
        if (Array.isArray(status)) {
            return status.some(s => s && s.toLowerCase().includes('trial'));
        }

        // Handle string (single selection or legacy data)
        if (typeof status === 'string') {
            return status.toLowerCase().includes('trial');
        }

        return false;
    }

    isStatusFitting(): boolean {
        if (!this.clientInData['status']) {
            return false;
        }

        let status = this.clientInData['status'];

        // Handle array (multiple selection)
        if (Array.isArray(status)) {
            return status.some(s => s && s.toLowerCase().includes('fitting'));
        }

        // Handle string (single selection or edit mode)
        if (typeof status === 'string') {
            return status.toLowerCase().includes('fitting');
        }

        return false;
    }

    isStatusCleaning(): boolean {
        if (!this.clientInData['status']) {
            return false;
        }

        let status = this.clientInData['status'];

        // Handle array (multiple selection)
        if (Array.isArray(status)) {
            return status.some(s => s && s.toLowerCase().includes('cleaning'));
        }

        // Handle string (single selection or edit mode)
        if (typeof status === 'string') {
            return status.toLowerCase().includes('cleaning');
        }

        return false;
    }

    /**
     * Load promo types for Phone Tracking
     */
    loadPromoTypes(): void {
        this.promoTypeService
            .getActivePromoTypes()
            .then((res: any) => {
                if (res && res.data) {
                    this.promoTypeOptions = res.data;
                }
            })
            .catch((error) => {
                console.error('Error loading promo types for Phone Tracking:', error);
            });
    }

    /**
     * Load promo references for Phone Tracking
     */
    loadPromoReferences(): void {
        this.promoReferenceService
            .getActivePromoReferences()
            .then((res: any) => {
                if (res && res.data) {
                    this.promoReferenceOptions = res.data;
                }
            })
            .catch((error) => {
                console.error('Error loading promo references for Phone Tracking:', error);
            });
    }

    /**
     * Handle promo change for Phone Tracking
     */
    onPromoChange(): void {
        if (this.clientInData['promo'] === 'No') {
            // Clear promo-related fields when promo is set to No
            this.clientInData['promo_type_id'] = '';
            this.clientInData['promo_type_display'] = '';
            this.clientInData['promo_reference_id'] = '';
            this.clientInData['promo_reference_display'] = '';
            this.clientInData['promo_reference_details'] = '';
            this.filteredPromoReferenceOptions = [];
        } else if (this.clientInData['promo'] === 'Yes') {
            // Ensure data is loaded when promo is set to Yes
            if (this.promoTypeOptions.length === 0) {
                this.loadPromoTypes();
            }
            if (this.promoReferenceOptions.length === 0) {
                this.loadPromoReferences();
            }
        }
    }

    /**
     * Handle promo type selection for Phone Tracking
     */
    onPromoTypeSelection(promoType: any): void {
        this.clientInData['promo_type_id'] = promoType.promo_type_id;
        this.clientInData['promo_type_display'] = promoType.promo_type;

        // Clear promo reference fields when promo type changes
        this.clientInData['promo_reference_id'] = '';
        this.clientInData['promo_reference_display'] = '';
        this.clientInData['promo_reference_details'] = '';

        // Filter promo references based on selected promo type
        this.filteredPromoReferenceOptions = this.promoReferenceOptions.filter(
            ref => ref.promo_type_id == promoType.promo_type_id
        );
    }

    /**
     * Handle promo reference selection for Phone Tracking
     */
    onPromoReferenceSelection(promoReference: any): void {
        this.clientInData['promo_reference_id'] = promoReference.promo_reference_id;
        this.clientInData['promo_reference_display'] = promoReference.promo_reference;
        this.clientInData['promo_reference_details'] = promoReference.promo_reference_details || '';
    }

    /**
     * Filter promo references by promo type ID for edit mode initialization
     */
    filterPromoReferencesByType(promoTypeId: any): void {
        this.filteredPromoReferenceOptions = this.promoReferenceOptions.filter(
            ref => ref.promo_type_id == promoTypeId
        );
    }

    /**
     * Load old reference from last walk-in entry for the selected client
     */
    loadOldReference(clientId: any): void {
        if (!clientId) return;

        this.clientWalkInService.getLastWalkInReference({ client_id: clientId })
            .then((response: any) => {
                if (response.success && response.data) {
                    this.clientInData['old_reference'] = response.data.reference_id;
                    this.clientInData['old_reference_display'] = response.data.reference_name;
                } else {
                    // Clear old reference if no previous entry found
                    this.clientInData['old_reference'] = '';
                    this.clientInData['old_reference_display'] = '';
                }
            })
            .catch((error) => {
                console.error('Error loading old reference:', error);
                this.clientInData['old_reference'] = '';
                this.clientInData['old_reference_display'] = '';
            });
    }

    /**
     * Load old reference display name for edit mode when we have the reference ID
     */
    loadOldReferenceDisplayName(referenceId: any): void {
        if (!referenceId) return;

        // First ensure itemList is loaded, then find the reference
        this.commonService.getReferenceList()
            .subscribe({
                next: (response: any) => {
                    if (response && response.length > 0) {
                        this.itemList = response;
                        const referenceItem = this.itemList.find(item => item.ref_id == referenceId);
                        if (referenceItem) {
                            this.clientInData['old_reference_display'] = referenceItem.name;
                        } else {
                            this.clientInData['old_reference_display'] = '';
                        }
                    }
                },
                error: (error) => {
                    console.error('Error loading reference list:', error);
                    this.clientInData['old_reference_display'] = '';
                }
            });
    }

    /**
     * Handle promo type input change for Phone Tracking
     */
    onPromoTypeInputChange(event: any): void {
        const typedValue = event.target.value;

        // Find matching promo type by name
        const matchingPromoType = this.promoTypeOptions.find(
            promoType => promoType.promo_type === typedValue
        );

        if (matchingPromoType) {
            this.onPromoTypeSelection(matchingPromoType);
        } else {
            // Clear references if no match found
            this.clientInData['promo_type_id'] = '';
            this.clientInData['promo_reference_id'] = '';
            this.clientInData['promo_reference_display'] = '';
            this.clientInData['promo_reference_details'] = '';
            this.filteredPromoReferenceOptions = [];
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/clientWalkIn/addClientWalkIn.component.ts